/* ==========================================================================
   TNF card rows 1.0.0                                   2026-09-24 (Brief 7)
   Every product card shows its name centred beneath the image and the black
   price badge centred beneath the name (assets/tnf-layout-1-0-0.css 2.1.0).
   This lines the badges up along each visual row of cards WITHOUT reserving
   empty space: in a row whose names wrap to different numbers of lines, the
   badge under a shorter name moves down to the level of the badge under the
   longest name. A row whose names share a line count is left alone, and so
   is a single-column list.
   - A row = cards in the same grid or carousel track whose top edges line up.
   - Layout values only (offsetTop, the computed height): the theme's reveal
     animations (transforms) never disturb the measurement.
   - Re-runs when cards arrive (infinite scroll, sort, recommendations,
     search), when any card name or grid changes size (window resize, a tab
     shown, a web font arriving) and after images load.
   Only the inline top margin of the badge row (.card-price--tnf, marked with
   data-tnf-rowfix) is touched. The names themselves are never resized: the
   theme animates every property of .card-title, which would feed back into
   the measurement. Without this script each badge simply follows its name.
   Markup: snippets/product-card.liquid, snippets/halo-product-card.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tnfCardRows) return;
  var API = window.__tnfCardRows = { version: '1.0.0', runs: 0, rows: 0, fixed: 0, why: {} };
  var HEAD = '.tnf-card-head', MARK = 'data-tnf-rowfix';
  var queued = 0, ro = null;
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;

  function layoutTop(el) { var y = 0; while (el) { y += el.offsetTop || 0; el = el.offsetParent; } return y; }
  function cellOf(h) { var it = h.closest('.product-item'); return (it && it.parentElement) || h.closest('li') || h.parentElement; }

  function watch(box) {
    if (!ro || !box || (watched && watched.has(box))) return;
    if (watched) watched.add(box);
    try { ro.observe(box); } catch (e) {}
  }

  function run() {
    queued = 0;
    var heads = document.querySelectorAll(HEAD), i, h, t, p, cell, box;
    // 1. group the visible cards into rows: same grid / track, same top edge. The names are never
    //    resized (the theme animates every property of .card-title), so their measured height is
    //    always their natural one; the badge row takes the difference as a top margin instead.
    var boxes = [], rowsOf = [];
    for (i = 0; i < heads.length; i++) {
      h = heads[i]; t = h.querySelector('.card-title'); p = h.querySelector('.card-price--tnf');
      if (!t || !p) continue;
      watch(t);                                                               // a name changing size re-runs
      cell = cellOf(h); box = cell && cell.parentElement;
      if (!box) continue;
      watch(box);
      if (!h.offsetParent || !h.offsetWidth || getComputedStyle(h).flexDirection !== 'column') {  // hidden, or a compact row
        if (p.hasAttribute(MARK)) { p.style.marginTop = ''; p.removeAttribute(MARK); }
        continue;
      }
      var bi = boxes.indexOf(box); if (bi < 0) { bi = boxes.push(box) - 1; rowsOf[bi] = {}; }
      var key = Math.round(layoutTop(cell));
      (rowsOf[bi][key] = rowsOf[bi][key] || []).push({ p: p, bottom: layoutTop(h) + (parseFloat(getComputedStyle(t).height) || t.offsetHeight) });
    }
    // 2. each row: every badge starts level with the badge under the row's longest name
    var nRows = 0, nFixed = 0;
    for (var b = 0; b < rowsOf.length; b++) {
      for (var k in rowsOf[b]) {
        var row = rowsOf[b][k], target = 0, j;
        if (row.length > 1) nRows++;
        for (j = 0; j < row.length; j++) target = Math.max(target, row[j].bottom);
        for (j = 0; j < row.length; j++) {
          var d = target - row[j].bottom, want = d > 0.25 ? d.toFixed(2) + 'px' : '';
          if (want) nFixed++;
          if (row[j].p.style.marginTop !== want) {
            row[j].p.style.marginTop = want;
            if (want) row[j].p.setAttribute(MARK, ''); else row[j].p.removeAttribute(MARK);
          }
        }
      }
    }
    API.runs++; API.rows = nRows; API.fixed = nFixed;
  }

  function schedule(why) {
    why = typeof why === 'string' ? why : 'other';
    API.why[why] = (API.why[why] || 0) + 1;
    if (queued) return;
    queued = 1;
    if (window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run, 16);
  }
  API.run = run; API.schedule = schedule;

  if (window.ResizeObserver) ro = new ResizeObserver(function () { schedule('size'); });
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && ((n.matches && n.matches(HEAD)) || (n.querySelector && n.querySelector(HEAD)))) { schedule('cards'); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('resize', function () { schedule('resize'); });
  window.addEventListener('load', function () { schedule('load'); });
  window.addEventListener('pageshow', function () { schedule('pageshow'); });
  document.addEventListener('load', function (e) {
    var el = e.target;
    if (el && el.tagName === 'IMG' && el.closest && el.closest('.product-item')) schedule('image');
  }, true);
  if (document.fonts) {
    if (document.fonts.ready) document.fonts.ready.then(function () { schedule('fonts'); }, function () {});
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { schedule('fonts'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule('ready'); });
  else schedule('ready');
})();
